<script setup>
import { computed } from 'vue'

import platformContent from '@/utils/authorization/testimonials.json'
import { maSessionStorage } from '@/lib/storage/index'
import { AUTH_PLATFORM } from '@/base/constants/Auth'

import MaTextWithUnderStrike from './MaTextWithUnderStrike.vue'

const isSearchAdsPlatform = computed(() => {
  return maSessionStorage.platform === AUTH_PLATFORM.SA
})

const platformData = computed(() => {
  return isSearchAdsPlatform.value ? platformContent.SEARCHADS_COM : platformContent.MA_DASHBOARD
})

// Randomly select a testimonial for either searchAds or MobileAction
const currentTestimonial = computed(() => {
  const testimonials = platformData.value.testimonials
  return testimonials[Math.floor(Math.random() * testimonials.length)]
})
</script>

<template>
  <div class="ma-auth-register-testimonials">
    <div class="quota">
      <img
        width="59" height="47"
        class="quota-symbol"
        src="https://files.mobileaction.co/public/icons/quote-symbol.svg"
      >
      <blockquote>
        {{ currentTestimonial.quote }}
      </blockquote>
      <div class="quota-author">
        <img :src="currentTestimonial.author.userImage" width="48" height="48">
        <span class="quota-author-name">{{ currentTestimonial.author.name }}</span>
        <span class="quota-author-profession">{{ currentTestimonial.author.profession }}</span>
        <img :src="currentTestimonial.author.logoImage" :alt="currentTestimonial.author.name" width="123" height="20">
      </div>
    </div>
    <div class="trusted">
      <MaTextWithUnderStrike>
        Trusted by
      </MaTextWithUnderStrike>
      <div class="trusted-logos"
      >
        <img
          v-for="brand in platformData.trustedBrands"
          :key="brand.logo"
          :src="brand.logo"
          :alt="brand.alt"
          class="trusted-logo"
          :class="[`trusted-logo--${brand.alt.toLowerCase().replace(' ', '-')}`]"
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ma-auth-register-testimonials {
  @apply hidden lg:flex flex-col bg-primary-dark min-h-screen w-[32.875rem] 2xl:w-4/12 rounded-l-[4rem] bg-right-top bg-no-repeat font-medium;
  background-image: url('https://files.mobileaction.co/public/background/line-patterns.svg');
  .quota {
    @apply mt-36 min-[1400px]:mt-56 2xl:my-auto px-16;
    &-symbol {
      @apply mb-12;
    }
    blockquote {
      @apply text-white text-xl leading-8 font-medium mb-10 w-[400px];
      span {
        @apply bg-no-repeat p-4 -ml-4 -mr-4 bg-[.35rem_.80rem];
        background-image: url('https://files.mobileaction.co/public/background/attention-mark.svg');
      }
    }
    &-author {
      @apply flex flex-col;
      &-name {
        @apply mt-2 font-medium text-white text-base;
      }
      &-profession {
        @apply font-medium text-gray-400 text-sm mb-8;
      }
    }
  }
  .trusted {
    @apply w-full flex flex-col gap-9 items-center p-11 mt-auto 2xl:mt-0;
    .ma-text-with-under-strike {
      @apply w-full text-gray-400 font-medium text-xs m-0;
      :deep(.ma-sep) {
        @apply bg-gray-700;
      }
    }
    &-logos {
      @apply flex items-center gap-6;
    }
    &-logo {
      &--meta {
        @apply w-full h-4;
      }
      &--starbucks {
        @apply w-full h-9;
      }
      &--square {
        @apply w-full h-5;
      }
      &--tango {
        @apply w-full h-9;
      }
      &--grammarly {
        @apply w-full h-8;
      }
    }
  }
}
</style>
